import { i18n } from '@/locales';
const lc = 'views.store_management.';
// 배달가맹관리비 유형(MONTHLY_CHARGE:월충전, MONTHLY_FIXED_AMOUNT:월정액, PER_CASE:건당)
// 기획문서: https://www.notion.so/barogohq/deliveryPayFlag-3b82342d67454ae9a999c68efe77d198
const deliveryPayFlagTypeCode = [
    'ALL',
    'PER_CASE',
    'MONTHLY_FIXED_AMOUNT',
    'MONTHLY_CHARGE',
];
export default deliveryPayFlagTypeCode.map((code, index) => ({
    text: i18n.t(`${lc}delivery_pay_flag_code_text[${index}]`),
    field: 'deliveryPayFlag',
    value: code,
}));
